// extracted by mini-css-extract-plugin
export default {"mCard":"DD-z","image":"ED-z","imageNoBackground":"FD-z","imageHasCategory":"GD-z","fullWidth":"HD-z"};